import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../../common/BaseComponent';
import { UserRoleDetails } from 'src/app/model/userRoleDetails';
import { Constants } from 'src/app/util/Constants';

@Component({
  selector: 'app-select-user-acc-err',
  templateUrl: './select-user-acc-err.component.html'
})

export class SelectUserAccErrComponent extends BaseComponent implements OnInit {
  searchResultscount: number = 0;
  userRoleDetails: UserRoleDetails;

  constructor(
    injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.searchResultscount = Number(sessionStorage.getItem("userListCount"));
    if (isNaN(this.searchResultscount)) {
      this.searchResultscount = 0;
    }

    const sessionUserRole = sessionStorage.getItem("searchUserRole");
    this.userRoleDetails = JSON.parse(sessionUserRole);
  }

  getTooManyMessage() {
    return this.translator.instant('bss.admin.selectUserAccErr.error.tooMany.description', { count: this.searchResultscount });
  }

  onBack() {
    this.router.navigate(['secure/paadmin/role/search']);
  }

  onNewSearch():void {
    this.newSearch();
  }
}
